import PageCard from 'src/components/PageCard';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useParams } from 'react-router-dom';
import { useGetMachineGroupQuery } from 'src/backend';
import DataField from 'src/components/DataField/DataField';
import { Chip, Divider } from '@mui/material';
import { SyncStatus, useMachineGroupContext } from './MachineGroupContext';

type Params = {
  id: string;
};

export default function MachineGroupDetailsOverview() {
  const { id } = useParams<Params>();
  const { data, isLoading } = useGetMachineGroupQuery(id);
  const { syncStatus } = useMachineGroupContext();
  const syncStatusColorMap = {
    [SyncStatus.Finished]: '#199a19',
    [SyncStatus.Failed]: '#f10808',
    [SyncStatus.Pending]: '#aecde5',
    [SyncStatus.Cancelled]: 'orange',
    [SyncStatus.InProgress]: '#72A5CD',
    [SyncStatus.Unknown]: '#c6c3c3',
    [SyncStatus.None]: '#c6c3c3',
  };

  return isLoading ? (
    ''
  ) : (
    <PageCard title="Overview" icon={<InfoOutlinedIcon />}>
      <DataField label="Group ID" value={data?.data.id} />
      <DataField label="Group name" value={data?.data.name} />
      <Divider sx={{ paddingTop: '1em' }} />
      <DataField label="Customer ID" value={data?.data.customerId} />
      <DataField label="Customer name" value={data?.data.customerName} />
      <Divider sx={{ paddingTop: '1em' }} />
      <DataField label="Machines count" value={data?.data.machinesCount} />
      <DataField
        label="Sync status"
        value={
          <Chip
            label={SyncStatus[syncStatus]}
            sx={{
              width: '10rem',
              color: 'white',
              background: syncStatusColorMap[syncStatus],
            }}
          />
        }
      />
      <Divider sx={{ paddingTop: '1em' }} />
      <DataField label="Created by" value={data?.data.createdBy} />
      <DataField label="Created at" value={data?.data.createdAt} />
      <DataField label="Last modified by" value={data?.data.lastModifiedBy} />
      <DataField label="Last modified at" value={data?.data.lastModifiedAt} />
      <Divider sx={{ paddingTop: '1em' }} />
    </PageCard>
  );
}
